module.exports = __webpack_public_path__ + "img/empty_image.8c79e7d7.png";